const SonkosPage = () => import('./index.vue')
const SonkosFilter = () => import('./_pages/sonkos_filter.vue')
import { EditorGuard } from '@/common/guard'

export default [
  {
    path: '/sonkos',
    beforeEnter: EditorGuard,
    component: SonkosPage,
    name: 'SonkosIndex'
  },
  {
    path: '/sonkos/select/:filter',
    component: SonkosFilter,
    name: 'SonkosFilter'
  }
]
